/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorHelper from 'app/mixins/ErrorHelper.jsx';
import { FormattedNumber } from 'react-intl';
import AnalyticsMixin from 'app/mixins/AnalyticsMixin.js';
import CCVersion14 from 'app/components/Subscription/CCVersions/CCVersion14.jsx';
import CCVersion15 from 'app/components/Subscription/CCVersions/CCVersion15.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import RecurlyModule from 'app/mixins/RecurlyModule.js';
import GetPlanData from 'app/utility/GetPlanData.js';
import UserMessages from 'app/modules/UserMessageModule.js';

const _months = [
    {month: '01', label: '01 - January'},
    {month: '02', label: '02 - February'},
    {month: '03', label: '03 - March'},
    {month: '04', label: '04 - April'},
    {month: '05', label: '05 - May'},
    {month: '06', label: '06 - June'},
    {month: '07', label: '07 - July'},
    {month: '08', label: '08 - August'},
    {month: '09', label: '09 - September'},
    {month: '10', label: '10 - October'},
    {month: '11', label: '11 - November'},
    {month: '12', label: '12 - December'}
];

const _years = [];
const _currentYear = new Date().getFullYear();

for (let i = 0; i <= 10; ++i) {
    _years.push({year: _currentYear + i, label: _currentYear + i});
}

class CreditCardModal extends React.Component {
    constructor(props) {
        super(props);

        let nameParts = [],
            first = '',
            last = '';

        if (this.props.firstName && this.props.lastName) {
            first = this.props.firstName;
            last = this.props.lastName;
        } else if (this.props.username) {
            nameParts = this.props.username.split("@");
            if (nameParts.length !== 2) {
                nameParts = this.props.username.split(" ");
            }
            first = nameParts[0];
            // hack for twitter social sign-in. the result of the split is ['', 'twitterhandle']
            // so we need to fill in the firstname to keep recurly from failing
            if (first === '') {
                first = 'dlvr.it';
            }
            last = (nameParts[1] !== undefined) ? nameParts[1] : '';
        }

        let addOns = 0;
        if (this.props.addOns !== null && this.props.addOns.add_on_social) {
            addOns = this.props.addOns.add_on_social;
        }

        this.state = {
            token: '',
            TDSToken: '',
            recurlyReady: false,
            recurlyConfigured: false,
            paymentInfo: {
                number: '',
                first_name: first,
                last_name: last,
                month: _months[new Date().getMonth()],
                year: _years[0],
                cvv: ''
            },
            recurlyErrors: null,
            challengeError: null,
            paymentType: 'card',
            planDetail: {},
            isSaving: false,
            planTerm: this.props.planTerm,
            has3DSChallenge: false,
            couponCode: '',
            couponError: '',
            isValidatingCoupon: false,
            isValidCoupon: null,
            addOns: addOns,
        };

        this.submitPaymentInfo = this.submitPaymentInfo.bind(this);
        this.recurlyCallback = this.recurlyCallback.bind(this);
        this.makeSubscriptionCall = this.makeSubscriptionCall.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.changePaymentType = this.changePaymentType.bind(this);
        this.changePaymentTerm = this.changePaymentTerm.bind(this);
        this.changeAddOns = this.changeAddOns.bind(this);
        this.isRecurlyConfigured = this.isRecurlyConfigured.bind(this);
        this.couponValidator = this.couponValidator.bind(this);
        this.validateCoupon = this.validateCoupon.bind(this);
        this.resetCoupon = this.resetCoupon.bind(this);
        this.onApplePayPaymentAuthorized = this.onApplePayPaymentAuthorized.bind(this);
        this.onApplePayCancel = this.onApplePayCancel.bind(this);

        this.debouncedCouponValidator = _.debounce(this.couponValidator, 1000);

    }

    componentDidMount() {

        let version = this.props.version,
            trialEligible = false;

        this.props.getSubscription();

        RecurlyModule.loadRecurly(this.props.app, (result) => {
            this.setState({
                recurlyReady: result
            });
            if (result) {
                RecurlyModule.generateRecurlyFields(this.props.app);
                let couponCode = '';
                if (this.props.router.query !== null && this.props.router.query.code !== undefined) {
                    couponCode = this.props.router.query.code;
                } else if (this.props.autoCouponCode !== undefined && this.props.autoCouponCode !== '') {
                    couponCode = this.props.autoCouponCode;
                }

                if (couponCode !== '') {
                    this.setState({
                        couponCode: couponCode
                    }, () => {
                        this.couponValidator();
                    });
                }
            }
            window.setTimeout(this.isRecurlyConfigured, 500);
        });

        if (dataLayer) {
            if (this.props.update !== 'update') {
                // dataLayer.push(
                //     {
                //         'event': 'show-payment-prompt',
                //         'plan-name': AnalyticsMixin.getPlanLabel(this.props.plan, this.state.planTerm)
                //     },
                //     {
                //         'event': 'checkout',
                //         'ecommerce': {
                //             'checkout': {
                //             'actionField': {'step': 2, 'option': 'Payment'}
                //         }
                //     }
                // });

                // GA4 specific data
                let planDetail = GetPlanData.lookupDetails(this.props.plan, this.state.planTerm);
                if (planDetail) {
                    // dataLayer.push({
                    //     'event': 'begin_checkout',
                    //     'currency': 'USD',
                    //     'value': planDetail.price,
                    //     items: [
                    //         {
                    //             item_id: 'dlvrit_1',
                    //             item_name: 'dlvr.it premium plan',
                    //             price: 1.00,
                    //             quantity: 1
                    //         }
                    //     ]
                    // });
                    if (gtag) {
                        let promoData = this.props.getPersistedData('gaPromo');

                        gtag('event', 'begin_checkout', {
            				currency: 'USD',
            				value: 1.0,
            				items: [{
            					item_id: 'dlvrit_1',
            					item_name: 'dlvr.it premium plan',
            					item_variant: 'New Plan',
            					price: 1.0,
            					quantity: 1,
                                promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
            				}],

            			});
                    }

                    if (this.props.recordEvent) {
                        let promoData = this.props.getPersistedData('gaPromo');
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Begin Checkout',
                            event_data: {
                                promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                            }
                        });
                    }
                }
            }
        }

        if (this.props.recordEvent && this.props.action === 'subscribe') {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Open CC Modal',
                    event_data: {
                        'selected-plan': this.props.plan,
                        'selected-term': this.state.planTerm,
                        'cc-modal-version': version,
                        'trial-eligible': trialEligible
                    }
                })
            }
        }

    }

    componentWillUnmount() {

        this.props.deleteApiError(['SUB_CREATE', 'SUB_UPDATE', 'SUB_UPDATE_BILLING']);

    }

    componentDidUpdate(prevProps, prevState) {
        let first = '',
            last = '',
            paymentInfo = this.state.paymentInfo,
            constants = this.props.app.config.constants;

        if (this.props.getApiErrors(['SUB_CREATE', 'SUB_UPDATE_BILLING']).length ) {
            let errors = this.props.getApiErrors(['SUB_CREATE', 'SUB_UPDATE_BILLING']),
                TDSChallenge = errors[0].errors?.subscription?.TDSChallenge;

            if (TDSChallenge !== undefined && TDSChallenge !== null && this.state.has3DSChallenge === false) {
                const risk = recurly.Risk();
                const threeDS = risk.ThreeDSecure({actionTokenId: TDSChallenge});

                threeDS.on('error', err => {
                    this.setState({
                        challengeError: err
                    });
                    threeDS.remove();
                });

                threeDS.on('token', token => {
                    this.makeSubscriptionCall(this.state.token, token.id);
                    this.setState({
                        has3DSChallenge: false,
                        isSaving: true
                    });
                    threeDS.remove();
                });

                threeDS.attach(document.querySelector('#threeDS-challenge'));

                this.setState({
                    has3DSChallenge: true
                });

                if (this.props.recordEvent) {
                    let context = this.props.getApiErrors(['SUB_CREATE']).length ? 'New Subscription' : 'Card Update';
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Show 3DS Challenge',
                            event_data: {
                                context
                            }
                        })
                    }
                }
            }
        }

        if ((this.props.isFreeOrTrialUser(prevProps.user.plan.planLevel) && !this.props.isFreeOrTrialUser(this.props.user.plan.planLevel)) ||
            (this.props.getApiErrors(['SUB_CREATE']).length || this.props.getApiErrors(['SUB_UPDATE_BILLING']).length)) {
            if (this.state.isSaving) {
                this.setState({
                    isSaving: false
                });
            }
        }

        if (this.state.paymentInfo.first_name === '' && this.state.paymentInfo.last_name === '') {
            if (this.props.firstName && this.props.lastName) {
                first = this.props.firstName;
                last = this.props.lastName;
            } else if (this.props.username) {
                let nameParts = this.props.username.split("@");
                // hack for facebook (maybe google) social sign-in
                if (nameParts.length !== 2) {
                    nameParts = this.props.username.split(" ");
                }
                first = nameParts[0];
                // hack for twitter social sign-in. the result of the split is ['', 'twitterhandle']
                // so we need to fill in the firstname to keep recurly from failing
                if (first === '') {
                    first = 'dlvr.it';
                }
                last = (nameParts[1] !== undefined) ? nameParts[1] : '';
            }
            if (first !== '' || last !== '') {
                paymentInfo.first_name = first;
                paymentInfo.last_name = last;
                this.setState({
                    paymentInfo
                });
            }
        }

        if (prevState.paymentType !== 'card' && this.state.paymentType === 'card') {
            if (this.state.recurlyReady) {
                RecurlyModule.generateRecurlyFields(this.props.app);
            }
        }

        if (prevState.recurlyConfigured === false && this.state.recurlyConfigured === true) {
            RecurlyModule.generateRecurlyFields(this.props.app);
        }

        if (prevProps.app.loading.SUB_VALIDATE_COUPON === true && this.props.app.loading.SUB_VALIDATE_COUPON === false) {
            let errors = this.props.getApiErrors(['SUB_VALIDATE_COUPON']),
                isValidCoupon = this.state.isValidCoupon;

            if (errors.length) {
                isValidCoupon = false;
                if (errors[0].errors.validation !== undefined && errors[0].errors.validation.code !== undefined) {
                    this.setState({
                        couponError: errors[0].errors.validation.code
                    }, () => {
                        this.props.deleteApiError(['SUB_VALIDATE_COUPON']);
                    });
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Invalid Coupon Used',
                            event_data: {
                                coupon: this.state.couponCode
                            }
                        });
                    }
                }
            } else {
                // apply coupon and show discounts
                isValidCoupon = true;
                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Coupon Applied',
                        event_data: {
                            coupon: this.state.couponCode
                        }
                    });
                }
            }

            this.setState({
                isValidatingCoupon: false,
                isValidCoupon
            });
        }

    }

    isRecurlyConfigured() {
        if (!recurly.configured) {
            window.setTimeout(this.isRecurlyConfigured, 500);
        } else {
            this.setState({
                recurlyConfigured: true
            });
        }
    }

    couponValidator() {
        let planDetail = GetPlanData.lookupDetails(this.props.plan, this.state.planTerm);

        this.props.validateCoupon({
            code: this.state.couponCode,
            plan: planDetail.plan_id
        });

        this.setState({
            isValidatingCoupon: true,
            couponError: ''
        });

    }

    validateCoupon(e) {
        let nextCouponCode = e.target.value;

        nextCouponCode = nextCouponCode.trim();

        this.setState({
            couponCode: nextCouponCode
        });

        this.debouncedCouponValidator();

    }

    resetCoupon(e) {
        if (e) {
            e.preventDefault();
        }

        this.props.resetCoupon();

        this.setState({
            couponCode: '',
            isValidCoupon: null,
            isValidatingCoupon: false,
            couponError: ''
        });
    }


    submitPaymentInfo(e) {

        let paymentInfo = _.clone(this.state.paymentInfo),
            subscriptionInfo = {},
            options = {},
            constants = this.props.app.config.constants,
            termLabel = '';

        // debounce multi-clicks
        if (this.state.isSaving) {
            return;
        }

        if (this.state.recurlyReady && recurly.configured) {

            this.setState({
                isSaving: true
            });

            let form = document.getElementById('recurly-form');

            // clear out prior errors
            this.props.deleteApiError(['SUB_CREATE', 'SUB_UPDATE', 'SUB_UPDATE_BILLING']);

            if (this.state.paymentType === 'card') {
                if (form) {
                    recurly.token(form, (err, token) => {
                        this.recurlyCallback(err, token);
                    });
                }
            } else if (this.state.paymentType === 'paypal') {
                termLabel = " Monthly";
                if (this.state.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                    termLabel = " Annual";
                }
                options.description = "dlvr.it " + this.props.plans.details[this.props.plan].label + termLabel;
                recurly.paypal(options, (err, token) => {
                    this.recurlyCallback(err, token);
                });
            }
        } else {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Recurly Not Loaded'
                })
            }
        }

    }

    makeSubscriptionCall(token, TDSToken) {

        if (this.props.action === 'subscribe') {
            let subscriptionInfo = {
                token: token,
                level: this.props.plan,
                term: this.state.planTerm,
                'first-name': this.state.paymentInfo.first_name,
                'last-name': this.state.paymentInfo.last_name
            };
            if (TDSToken) {
                subscriptionInfo.TDSToken = TDSToken;
            }
            if (this.state.addOns !== 0) {
                subscriptionInfo.add_on_social = this.state.addOns;
            }
            if (this.props.firstPullFlag !== null) {
                subscriptionInfo.firstPullFlag = this.props.firstPullFlag;
            }
            if (this.state.couponCode && this.state.isValidCoupon) {
                subscriptionInfo.coupon_codes = [this.state.couponCode];
            }
            if (this.props.isHammertime) {
                subscriptionInfo.isHammertime = true;
            }
            if (this.props.app.triggeredErrors.socialMove) {
                subscriptionInfo.socialMove = true;
            }
            this.props.createSubscription(subscriptionInfo);
        }  else {
            let updateInfo = {
                token: token,
                firstName: this.props.firstName,
                lastName: this.props.lastName
            };
            if (TDSToken) {
                updateInfo['TDSToken'] = TDSToken;
            }
            this.props.updateBillingInfo(updateInfo);
        }

    }

    recurlyCallback(err, token) {

        let paymentType = '',
            subscriptionInfo = {};

        switch (this.state.paymentType) {
            case 'card':
                paymentType = 'cc';
                break;

            default:
                paymentType = this.state.paymentType;
        }

        if (err) {
            if (dataLayer) {
                if (this.props.action !== 'update') {
                    dataLayer.push({
                        'event': 'plan-subscription-error',
                        'payment-type': paymentType
                    });
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Recurly Token Generation Error',
                            event_data: {
                                'payment-type': paymentType,
                                'payment-error': JSON.stringify(err)
                            }
                        })
                    }
                }
            }
            this.setState({
                recurlyErrors: err,
                isSaving: false
            });
        } else {
            this.setState({
                token: token.id
            });

            // GA4 event
            if (dataLayer) {
                dataLayer.push({
                    'event': 'add_payment_info',
                    'payment_type': paymentType
                });
            }

            this.makeSubscriptionCall(token.id);

        }

    }

    onSelect(val) {

        let paymentInfo = this.state.paymentInfo;

        if (val.month) {
            paymentInfo.month = val;
        }

        if (val.year) {
            paymentInfo.year = val;
        }

        this.setState({
            paymentInfo
        });

    }

    changePaymentType(e) {
        let paymentType = '';

        if (e.currentTarget.value !== undefined) {
            paymentType = e.currentTarget.value;
        } else if (e.currentTarget.dataset.value !== undefined) {
            paymentType = e.currentTarget.dataset.value;
        }

        if (paymentType === 'paypal') {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'PayPal Selected',
                    event_data: {}
                })
            }
        }

        if (paymentType === 'applepay') {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'ApplePay Selected',
                    event_data: {}
                })
            }
        }

        this.setState({
            paymentType
        });

    }

    changePaymentTerm(e) {
        let term = parseInt(e.currentTarget.dataset.term),
            duplicate = {
                currentTarget: {
                    dataset: parseInt(e.currentTarget.dataset)
                }
            },
            planDetail = GetPlanData.lookupDetails(this.props.plan, term),
            constants = this.props.app.config.constants;


        this.setState({
            planTerm: term
        });

        // check to make sure if a coupon is present
        // it's applicable to the term selected if not, blank it
        if (!_.isEmpty(this.props.plans.validatedCoupon)) {
            if (!this.props.plans.validatedCoupon.discount.appliesToAllPlans) {
                let isValidCoupon = this.state.isValidCoupon,
                    couponError = this.state.couponError;

                if (this.props.plans.validatedCoupon.discount.plans.find(({code}) => {
                        return code === planDetail.plan_id;
                    }) === undefined) {
                    isValidCoupon = false;
                    if (term === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        couponError = `${this.state.couponCode} isn't valid for monthly plans`;
                    } else {
                        couponError = `${this.state.couponCode} isn't valid for annual plans`;
                    }

                } else {
                    isValidCoupon = true;
                    couponError = "";
                }

                this.setState({
                    isValidCoupon,
                    couponError
                });
            }
        } else if (!_.isEmpty(this.state.couponCode)) {
            this.props.validateCoupon({
                code: this.state.couponCode,
                plan: planDetail.plan_id
            });

            this.setState({
                isValidatingCoupon: true,
                couponError: ''
            });
        }

        this.props.changeTerm(duplicate);

    }

    changeAddOns(plan, quantity) {
        this.setState({
            addOns: quantity
        });
    }

    onApplePayPaymentAuthorized({payment}) {
        const { recurlyToken: token, recurlyToken, billingContact, shippingContact } = payment;

        this.makeSubscriptionCall(token.id);

    }

    onApplePayCancel() {
        this.setState({
            isSaving: false
        });
    }

    render() {
        let constants = this.props.app.config.constants,
            planLabel = '',
            termLabel = '',
            priceLabel = '',
            content = null,
            paymentBlock = null,
            recurlyMsg = '',
            buttonLabel = null,
            buttonAction = null,
            version = this.props.version,
            sendPromoView = false,
            buttonClass = '',
            ccNumber = (this.props.paymentInfo && this.props.paymentInfo.number) ? this.props.paymentInfo.number : '',
            ccCVV = (this.props.paymentInfo && this.props.paymentInfo.cvv) ? this.props.paymentInfo.cvv : '',
            prices = null,
            addOnPrices = null,
            cardNumberClass = 'cc-number',
            pcPlaceholder = 'Postal Code (US only)';

        if (this.props.plans.details[this.props.plan] !== undefined && this.props.plans.details[this.props.plan].label) {
            planLabel = this.props.plans.details[this.props.plan].label;
        }

        termLabel = (this.state.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) ? 'Year' : 'Month';

        if (this.props.plans.details[this.props.plan] !== undefined && this.props.plans.details[this.props.plan].price) {
            priceLabel = (<FormattedNumber value={this.props.plans.details[this.props.plan].price[this.state.planTerm]} style="currency" currency="USD" />);
            prices = this.props.plans.details[this.props.plan].price;
        }

        if (this.props.plans.details[this.props.plan] !== undefined && this.props.plans.details[this.props.plan].addOnPrices) {
            addOnPrices = this.props.plans.details[this.props.plan].addOnPrices;
        }

        if (this.state.isSaving) {
            buttonLabel = "Processing";
            buttonAction = null;
            buttonClass = "upgrade-submit processing";
        } else {
            buttonLabel = "Checkout now";
            buttonAction = this.submitPaymentInfo;
            buttonClass = "upgrade-submit"
        }

        // modified placeholder for v16
        // if (parseInt(this.props.user.id, 10) % 2 !== 0) {
        //     pcPlaceholder = 'Postal Code (US only)'
        // }
        //
        // <div className="input-group expiration clearfix">
        //     <div className="input-block expr-month">
        //         <label className="field-info error month">{ErrorHelper.getRecurlyErrorForField(this.state.recurlyErrors, 'month')}</label>
        //         <div data-reculry="month"></div>
        //     </div>
        //     <div className="input-block expr-year">
        //         <label className="field-info error year">{ErrorHelper.getRecurlyErrorForField(this.state.recurlyErrors, 'year')}</label>
        //         <div data-recurly="year"></div>
        //     </div>
        //     <div className="input-block cc-cvv">
        //         <label className="field-info error cvv">{ErrorHelper.getRecurlyErrorForField(this.state.recurlyErrors, 'cvv')}</label>
        //         <div data-recurly="cvv"></div>
        //     </div>
        // </div>

        // show credit card fields else show paypal
        if (this.state.paymentType === 'card') {
            paymentBlock = (
                <div className="credit-card-form">
                    <input type="hidden" name="recurly-first-name" data-recurly="first_name" value={this.state.paymentInfo.first_name}/>
                    <input type="hidden" name="recurly-last-name" data-recurly="last_name" value={this.state.paymentInfo.last_name.replace("@", '')}/>
                    <div className="input-group number clearfix">
                        <div id="card-block" className="input-block cc-number">
                            <label className="field-info error number">{ErrorHelper.getRecurlyErrorForField(this.state.recurlyErrors, 'number')}</label>
                            <div data-recurly="card"></div>
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.paymentType === 'paypal') {
            paymentBlock = (
                <div className="paypal-info clearfix">
                    <i className="fa fa-bell-o" style={{marginRight: '5px'}}></i>Turn off pop-up blockers. Paypal.com will open in a new window.<br/><br/>
                </div>
            );
        }

        if (this.state.recurlyErrors) {
            recurlyMsg = "We could not complete your purchase. Please check your card details and try again.";
        } else if (this.state.challengeError) {
            if (this.state.challengeError.code !== undefined && this.state.challengeError.code === '3ds-auth-error') {
                recurlyMsg = this.state.challengeError.message;
            }
        } else if (this.props.getApiErrors(['SUB_CREATE']).length) {
            if (_.isString(this.props.getApiErrors(['SUB_CREATE'])[0].errors.subscription)) {
                recurlyMsg = this.props.getApiErrors(['SUB_CREATE'])[0].errors.subscription;
            } else {
                if (this.props.getApiErrors(['SUB_CREATE'])[0].errors.subscription !== undefined) {
                    recurlyMsg = this.props.getApiErrors(['SUB_CREATE'])[0].errors.subscription.message;
                } else {
                    recurlyMsg = "There was an error";
                }
            }
        } else if (this.props.getApiErrors(['SUB_UPDATE_BILLING']).length) {
            if (this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.subscription !== undefined) {
                if (_.isString(this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.subscription)) {
                    recurlyMsg = this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.subscription;
                } else {
                    recurlyMsg = this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.subscription.message;
                }
            } else if (this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.message !== undefined) {
                recurlyMsg = this.props.getApiErrors(['SUB_UPDATE_BILLING'])[0].errors.message;
            }
        }

        // If the expr date OR cvv is incorrect, Recurly provides a message stating the CVV is incorrect
        // hack the message so we can get the user to look at, and verify *both* fields
        if (_.isString(recurlyMsg) && recurlyMsg.match(/cvv/i)) {
            recurlyMsg = "The expiration date or security code you entered does not match. Please update and try again."
        }

        if (version === 0) {
            version = parseInt(this.props.user.id, 10) % 2;
            if (recurlyMsg === '') {
                sendPromoView = true;
            }
        }

        return (
            <CCVersion15
                {...this.props}
                heading={this.props.heading}
                planLabel={planLabel}
                planTerm={this.state.planTerm}
                priceLabel={priceLabel}
                termLabel={termLabel}
                recurlyMsg={recurlyMsg}
                changePaymentType={this.changePaymentType}
                paymentType={this.state.paymentType}
                paymentBlock={paymentBlock}
                buttonClass={buttonClass}
                buttonLabel={buttonLabel}
                buttonAction={buttonAction}
                closeAction={this.props.closeAction}
                sendPromoView={sendPromoView}
                action={this.props.action}
                prices={prices}
                addOnPrices={addOnPrices}
                changeTerm={this.changePaymentTerm}
                addOns={this.state.addOns}
                changeAddOns={this.changeAddOns}
                couponCode={this.state.couponCode}
                couponError={this.state.couponError}
                isValidatingCoupon={this.state.isValidatingCoupon}
                isValidCoupon={this.state.isValidCoupon}
                validateCoupon={this.validateCoupon}
                resetCoupon={this.resetCoupon}
                onApplePayPaymentAuthorized={this.onApplePayPaymentAuthorized}
                onApplePayCancel={this.onApplePayCancel}
                recurlyConfigured={this.state.recurlyConfigured}
                recurlyCallback={this.recurlyCallback} />
        );


    }

};

CreditCardModal.displayName = "CreditCardModal";

CreditCardModal.propTypes = {
    plan: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    planTerm: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    planPrice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    username: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    router: PropTypes.object,
    closeAction: PropTypes.func,
    action: PropTypes.string, //'subscribe' or 'update',
    heading: PropTypes.string,
    version: PropTypes.number,
    errors: PropTypes.object,
    addOns: PropTypes.object,
    addOnsCount: PropTypes.number,
    isHammertime: PropTypes.bool
};

CreditCardModal.defaultProps = {
    plan: 0,
    planTerm: 0,
    planPrice: 0,
    username: '',
    firstName: '',
    lastName: '',
    router: null,
    closeAction: null,
    action: 'subscribe',
    heading: '',
    version: 0,
    errors: null,
    changeTerm: null,
    addOns: null,
    addOnsCount: 0,
    isHammertime: false
};

export default CreditCardModal;
